// URL helpers for Google Search + Maps integration.

export function searchUrl(restaurant) {
  const q = (restaurant || "best ranch dressing restaurants") + " near me";
  return "https://www.google.com/search?q=" + encodeURIComponent(q);
}

export function mapsSearchUrl(name) {
  return (
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(name + " restaurant")
  );
}

// Query used for the map embed + "Open in Google Maps" pill.
export function mapQueryFor(restaurant) {
  return restaurant
    ? restaurant + " restaurant"
    : "chicken wings restaurants near me";
}

export function mapsQueryUrl(query) {
  return (
    "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(query)
  );
}

export function mapEmbedSrc(query) {
  return (
    "https://maps.google.com/maps?q=" + encodeURIComponent(query) + "&z=12&output=embed"
  );
}
